import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Missing Supabase environment variables. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env.local'
  );
}

const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const demoRole = params?.get('demo_role');
const storageKey = demoRole ? `vouch-auth-${demoRole}` : 'vouch-auth';

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      // Use sessionStorage so each browser tab gets its own session.
      // This allows 3 tabs logged in as 3 different demo personas simultaneously.
      storage: typeof window !== 'undefined' ? window.sessionStorage : undefined,
      storageKey,
      // Bypass the Navigator Lock API (navigator.locks.request) which throws
      // "AbortError: signal is aborted without reason" in some environments.
      // Since each tab has its own sessionStorage, cross-tab locking is unnecessary.
      lock: async (_name, _acquireTimeout, fn) => await fn(),
    },
  }
);

// Helper: retry a Supabase query on transient errors during auth init.
// Covers AbortError, 406 (`.single()` returning 0 rows due to RLS timing),
// and 403 (RLS policy blocks before auth token is set on the connection).
export async function withRetry(queryFn, maxRetries = 3) {
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    const result = await queryFn();
    const msg = result.error?.message || '';
    const code = result.error?.code;
    const isTransient =
      msg.includes('aborted') ||
      code === 'PGRST116' ||  // .single() returned 0 rows (406)
      result.status === 406 ||
      result.status === 403;
    if (isTransient && attempt < maxRetries) {
      await new Promise(r => setTimeout(r, 300 * (attempt + 1)));
      continue;
    }
    return result;
  }
}
